import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Skeleton } from 'components/UnvUI'
import { TextField, Button } from '@mui/material'

import $api from 'http/index'

import styles from './ArchivePage.module.scss'

const OcrSearchPage = () => {
  const { t } = useTranslation('common')

  const navigate = useNavigate()
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [searched, setSearched] = useState(false)

  const search = async (e) => {
    if (e) e.preventDefault()
    if (!query.trim()) return
    setLoading(true)
    setError(false)
    setSearched(true)
    try {
      const res = await $api.get('/archive/ocr-search/', { params: { q: query } })
      setResults(res.data?.results || res.data || [])
    } catch {
      setError(true)
      setResults([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('archive.ocr_title_page')}</h1>
      </div>

      <form className={`unv-card ${styles.searchBar}`} onSubmit={search}>
        <TextField
          fullWidth
          size="small"
          placeholder={t('archive.ocr_search_placeholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Button type="submit" variant="contained" disabled={!query.trim() || loading}>
          Найти
        </Button>
      </form>

      <div className={`unv-card ${styles.content}`}>
        {loading ? (
          <div className={styles.loaderWrap}>
            <Skeleton variant="table" rows={5} cols={4} />
          </div>
        ) : error ? (
          <div className="unv-empty">{t('schedule.section_in_dev')}</div>
        ) : !searched ? (
          <div className="unv-empty">{t('archive.ocr_enter_query')}</div>
        ) : results.length === 0 ? (
          <div className="unv-empty">{t('archive.ocr_no_matches')}</div>
        ) : (
          <table className="unv-table unv-table--clickable">
            <thead>
              <tr>
                <th>{t('archive.ocr_col_case_no')}</th>
                <th>{t('archive.ocr_col_doc_type')}</th>
                <th>{t('archive.ocr_col_snippet')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {results.map((r) => (
                <tr key={r.id || `${r.case_id}-${r.document_id}`}>
                  <td>{r.case_number || r.case_id || '—'}</td>
                  <td>{r.document_type || r.doc_type || '—'}</td>
                  <td className={styles.snippet}>{r.snippet || r.match || '—'}</td>
                  <td>
                    {/* Wave 4: маршрут /archive/cases/:id отсутствует, временно ведём в общий /archive/ (TODO: реализовать страницу дела). */}
                    <button
                      className="unv-btn unv-btn--sm"
                      onClick={() => navigate(`/archive/?case=${r.case_id}`)}
                    >
                      Открыть дело
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default OcrSearchPage
